import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

// A protected route component
const ProtectedRoute = ({ children, allowedRoles }) => {
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true); // Add loading state

  useEffect(() => {
    // Get user role or admin status from localStorage
    const storedIsAdmin = localStorage.getItem('isAdmin'); // '1' or '0' or maybe boolean-like
    const storedAdminType = localStorage.getItem('admin_type') || (() => {
      // some places may store the whole user object
      try {
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        return user.admin_type;
      } catch {
        return null;
      }
    })();

    setRole(storedIsAdmin);
    // store adminType in ref state for checks
    if (storedAdminType) {
      // append admin type to role for downstream check via allowedRoles
      setRole((r) => r);
      // save to session storage for later use by the component
      // but we'll keep checks below using both values
    }

    // attach values to window (local check) - not required but keeps parity
    setLoading(false); // Set loading to false once data is fetched
  }, []);

  // Show loading screen if data is still being fetched
  if (loading) {
    return <div>Loading...</div>; // You can replace this with a spinner or more detailed loading message
  }

  // If the role is not available or doesn't match, redirect to login page
  // Additional check: allow based on admin_type (e.g., 'gestion_stock') stored in localStorage or inside user
  const storedAdminType = localStorage.getItem('admin_type') || (() => {
    try {
      const user = JSON.parse(localStorage.getItem('user') || '{}');
      return user.admin_type;
    } catch {
      return null;
    }
  })();

  // Normalize isAdmin truthiness (localStorage stores strings)
  const storedIsAdmin = localStorage.getItem('isAdmin');
  const isAdminTrue = storedIsAdmin === '1' || storedIsAdmin === 'true' || storedIsAdmin === 'True';

  // Accept if stored isAdmin value matches any allowed role OR (user is admin AND admin_type matches)
  const allowedByIsAdmin = role && allowedRoles.includes(role);
  const allowedByAdminType = isAdminTrue && storedAdminType && allowedRoles.includes(storedAdminType);

  if (!allowedByIsAdmin && !allowedByAdminType) {
    return <Navigate to="/login" />; // Redirect to login page
  }

  // Otherwise, render the children (the protected route content)
  return children;
};

export default ProtectedRoute;
